import React from "react";
import { Link } from "react-scroll";

function Footer() {
  return (
    <footer className="p-4 bg-white shadow md:flex md:items-center md:justify-between md:p-6 dark:bg-gray-800">
      <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
        © 2022 Designed & Developed by{" "}
        <Link
          className="cursor-pointer text-white hover:text-purple-400"
          to="home"
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
        >
          Vivekanand Padala
        </Link>
      </span>
    </footer>
  );
}

export default Footer;
